/* eslint-disable prefer-const */
/* eslint-disable prettier/prettier */
/* eslint-disable no-use-before-define */
/* eslint-disable no-await-in-loop */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import * as Sentry from "@sentry/react";
import Checkbox from "@mui/material/Checkbox";
import { TableCell, TableRow, Tooltip } from "@mui/material";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import AppliedFilter from "../Reports/Components/AppliedFilter/AppliedFilter";
// import { DATES, EVENT_NAME, Constants } from "../Components/constant";
// import useParamsQuery from "../Components/hooks/useParamsQuery";
// import { isEmptyObj } from "../Components/helper";
// import AdvancedSearch from "../Reports/TotalReceiptReport/Components/NewAdvanceSearch";
import AdvancedSearch from "./Componenets/NewAdvanceSearch";
import styles from "./chapterLevelContributionCycle.styles";
import DateRangePicker from "../Reports/Components/DateRangePicker/DateRangePicker";
// import OrganizationStructure from "../Reports/Components/OrganizationStructureNew/OrganizationStructure";
import OrganizationStructure from "./Componenets/OrganizationStructure";
import Popover from "../Reports/Components/Popover/NewPopover";
// import { getFilters, getRoutePath } from "./utils";
import { SERVICES } from "../../components/Layout/Services";
import Loader from "../../components/Loader/Loader";
import SearchIconWithPeople from "../../components/Svg/SearchIconWithPeople";
import EmptyFileIcon from "../../components/Svg/EmptyFile";
import PageSyncCal from "../../components/Layout/PageSyncCal";
import Heading from "../../components/Layout/Heading";
import { OuterContainerStyles } from "../../components/Layout/Typography";
import { get, post } from "../../components/Layout/ApiHandler/apihandler";
// import GenericTable from "../../../components/Layout/Table/GenericTable";
// import GenericTable from "./Components/GenericTable";
import Button from "../../components/Layout/Button";
import PersonalDetailsSearch from "../Reports/TotalReceiptReport/Components/PersonalDetailsSearch";
import { ToastAlertContext } from "../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../contants";
import NewTable from "../PendingOnlineContribution/Components/NewTable/NewTable";
import Pagination from "../../components/Layout/Pagination";
import AutoCompleteDropdown from "../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";
// import ExportButton from "./components/ExportButton/ExportButton";
// import ExportButton from "./Components/ExportButton/ExportButton";

const LOADER_DELAY = 1000;
const PAGE = "page";

const initialFormValue = {
  dateOfBirthFrom: new Date(),
  dateOfBirthTo: new Date(),
};
const getOptions = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    value: opt[key],
  }));
function ChapterLevelContributionCycleDetails() {
  const TITLE = "Chapter Contribution Cycle Details - BSG ContributionAdmin";
  const [searchData, setSearchData] = useState({});
  const [data, setData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const formRef = useRef(null);
  const navigate = useNavigate();
  const metaData = useSelector((state) => state.meta);
  const [currentPage, setCurrentPage] = useState(0);
  const [clearContributions, setClearContributions] = useState(false);
  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);
  const [selectedSortMethod, setSelectedSortMethod] = useState("");
  const [values, setValues] = useState({
    areaId: null,
    clusterId: null,
    zoneId: null,
    regionId: null,
    chapterId: null,
    districtId: null,
    blockId: null,
  });
  const [orgNames, setOrgNames] = useState({
    areaName: null,
    clusterName: null,
    zoneName: null,
    regionName: null,
    chapterName: null,
    districtName: null,
    blockName: null,
  });
  const [searchPerformed, setSearchPerformed] = useState(false);
  const toast = useContext(ToastAlertContext);
  const [personalDetails, setPersonalDetails] = useState({
    memberId: null,
    fullName: null,
  });
  const [amountValue, setAmountValue] = useState(null);
  const [orderIdValue, setOrderIdValue] = useState(null);
  const [dataEnetrdBy, setDataEnetrdBy] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [selectedBankType, setSelectedBankType] = useState("");
  const [selectedBankName, setSelectedBankName] = useState("");
  const [bankTypes, setBankTypes] = useState([]);
  const [rowBankSelections, setRowBankSelections] = useState({});
  // const [rowBankSelectionsAfterFetch, setRowBankSelectionAfterFetch] = useState(
  //   {},
  // );
  const handleAmountChange = (value) => {
    setAmountValue(value);
  };
  const handleOrderIdChange = (value) => {
    setOrderIdValue(value);
  };
  const handleDataEnterdBy = (value) => {
    setDataEnetrdBy(value);
  };
  const updateSortingMethod = (value) => {
    setSelectedSortMethod(value);
  };
  const handlePersonalDetailsChange = (name, value) => {
    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };
  const [advancedSearchValues, setAdvancedSearchValues] = useState({
    selectedPayableCity: [],
    selectedPaymentMethod: [],
    selectedPaymentGateway: [],
    selectedUinType: [],
    selectedReceiptType: [],
  });
  const updateOrganizationStructureValues = (updatedValues) => {
    setValues(updatedValues);
  };

  function formatDateToYYYYMMDD(date) {
    return moment(date).format("YYYY-MM-DD");
  }
  function formatDateToYYYMMDDTimeStamp(date) {
    return moment(date).format("YYYY-MM-DDTHH:mm:ss");
  }
  const constructQueryParameters = () =>
    // formattedStartDate,
    // formattedEndDate,
    // selectedSortMethod,
    {
      const queryParams = [];
      const optionalParams = {
        areaId: values.areaId,
        clusterId: values.clusterId,
        zoneId: values.zoneId,
        regionId: values.regionId,
        chapterId: values.chapterId,
        districtId: values.districtId,
        blockId: values.blockId,
        // Add personal details
        memberId: personalDetails.memberId,
        fullName: personalDetails.fullName,
        // Add advanced search values
        payableCities: advancedSearchValues.selectedPayableCity.join(","),
        paymentMethodTypes:
          advancedSearchValues.selectedPaymentMethod.join(","),
        paymentGatewayTypes:
          advancedSearchValues.selectedPaymentGateway.join(","),
        uinTypes: advancedSearchValues.selectedUinType.join(","),
        receiptType: advancedSearchValues.selectedReceiptType.join(","),
        // id: dataEnetrdBy,
      };
      for (const key in optionalParams) {
        if (
          optionalParams[key] !== null &&
          optionalParams[key] !== undefined &&
          optionalParams[key] !== ""
        ) {
          queryParams.push(`${key}=${optionalParams[key]}`);
        }
      }
      // if (
      //   moment(formattedStartDate, "YYYY-MM-DD", true).isValid() &&
      //   moment(formattedEndDate, "YYYY-MM-DD", true).isValid()
      // ) {
      //   queryParams.push(`from=${formattedStartDate}`);
      //   queryParams.push(`to=${formattedEndDate}`);
      // }
      if (amountValue) {
        queryParams.push(`amount=${amountValue}`);
      }
      if (orderIdValue) {
        queryParams.push(`orderId=${orderIdValue}`);
      }
      if (dataEnetrdBy) {
        queryParams.push(`dataEnteredBy=${dataEnetrdBy}`);
      }
      // if (selectedSortMethod) {
      //   queryParams.push(`sort=${selectedSortMethod}`);
      // }
      return queryParams.join("&");
    };
  // const removeFilter = () => {
  //   setClearContributions(true);
  //   setSearchParams("");
  //   setPersonalDetails({
  //     memberId: null,
  //     fullName: null,
  //   });
  //   setTimeout(() => {
  //     setClearContributions(false);
  //     setSearchPerformed(false);
  //     // setShowFilter(false);
  //   }, 100);
  // };
  const handleBankTypes = async () => {
    try {
      // const url = `${SERVICES.GET_BSG_BANKS}`;
      const url = `${SERVICES.BANKS_DETAILS}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const bankList = data?.data?.content;
        setBankTypes(bankList);
        for (const bank of bankList) {
          const bankId = bank.id;
          const branchUrl = `${SERVICES.BANKS_DETAILS}/${bankId}/branches`;
          const branchResponse = await get(branchUrl);

          if (branchResponse.ok) {
            const branchData = await branchResponse.json();
            const defaultBranch = branchData.data.find(
              (branch) => branch.defaultForCa === true,
            );

            if (defaultBranch) {
              setSelectedBankType(defaultBranch?.bank?.id);
            }
          }
        }
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const validateBankDetails = () => {
    if (!values.areaId) {
      toast.show("Please Select Area", AlertStatus.ERROR);
      return false;
    }
    // if (!values.zoneId) {
    //   toast.show("Please Select Zone", AlertStatus.ERROR);
    //   return false;
    // }
    // if (!values.regionId) {
    //   toast.show("Please Select Region", AlertStatus.ERROR);
    //   return false;
    // }
    return true;
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validateBankDetails()) {
      return;
    }
    setSearchPerformed(true);
    if (
      !initialAdvanceFormValue.dateOfBirthFrom ||
      !initialAdvanceFormValue.dateOfBirthTo
    ) {
      toast.show("Please select date", AlertStatus.ERROR);
      return;
    }
    const formattedStartDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.dateOfBirthFrom,
    );
    const formattedEndDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.dateOfBirthTo,
    );
    try {
      setIsLoading(true);
      const url = `${
        SERVICES.CHAPTER_CONTRIBUTION_CYCLE
      }?${constructQueryParameters(
        formattedStartDate,
        formattedEndDate,
        selectedSortMethod,
      )}&size=${500}`;
      const response = await get(url);
      // console.log(response);
      if (response.ok) {
        const data = await response.json();
        const chapters = data?.data?.content;
        const activeChapters = chapters.filter(
          (item) => item.status === "ACTIVE",
        );
        const activeChapterIds = activeChapters.map((item) => item.chapterId);
        // const filteredData = data?.data?.content.filter(
        //   (item) => item?.paymentOrder?.captureVerified !== true,
        // );
        setSelectedItems(activeChapterIds);
        setSearchData(data.data);
        setData(data?.data?.content);
        // console.log("viewData", data?.data?.content);
        // setRowBankSelectionAfterFetch()
        // data?.data?.content.forEach(chapter => {
        //   state[chapter.chapterId] = chapter.defaultDepositBankId;
        // });
        // const bankSelection = data.reduce((acc, item) => {
        //   if (item.chapterId && item.defaultDepositBankId !== null) {
        //     acc[item.chapterId] = item.defaultDepositBankId;
        //   }
        //   return acc;
        // }, {});

        // console.log("bankSelection", bankSelection);
        // setRowBankSelectionAfterFetch(bankSelection);
        const areAllActive = data?.data?.content?.every(
          (item) => item.status === "ACTIVE",
        );

        if (areAllActive) {
          setSelectAll(true);
        } else {
          setSelectAll(false);
        }
        const bankSelection = data?.data?.content?.reduce((acc, item) => {
          if (item.chapterId && item.defaultDepositBankId !== null) {
            acc[item.chapterId] = item.defaultDepositBankId;
          }
          return acc;
        }, {});

        // Set the bank selection in state
        // console.log("bankSelection", bankSelection);
        setRowBankSelections(bankSelection);
        const queryParams = constructQueryParameters(
          formattedStartDate,
          formattedEndDate,
          selectedSortMethod,
        );
        const { areaId, clusterId, zoneId, regionId, chapterId, districtId, blockId } =
          values;

        const {
          areaName,
          clusterName,
          zoneName,
          regionName,
          chapterName,
          districtName,
          blockName,
        } = orgNames;
        const orgParams = [
          areaId !== null && areaName !== null && areaName !== ""
            ? `areaName=${areaName}`
            : "",
          clusterId !== null && clusterName !== null && clusterName !== ""
            ? `clusterName=${clusterName}`
            : "",
          zoneId !== null && zoneName !== null && zoneName !== ""
            ? `zoneName=${zoneName}`
            : "",
          regionId !== null && regionName !== null && regionName !== ""
            ? `regionName=${regionName}`
            : "",
          chapterId !== null && chapterName !== null && chapterName !== ""
            ? `chapterName=${chapterName}`
            : "",
          districtId !== null && districtName !== null && districtName !== ""
            ? `districtName=${districtName}`
            : "",
          blockId !== null && blockName !== null && blockName !== ""
            ? `blockName=${blockName}`
            : "",
        ]
          .filter(Boolean)
          .join("&");
        setSearchParams(`${queryParams}${orgParams ? `&${orgParams}` : ""}`);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    }
  };
  const handlePageChange = async (selectedPage) => {
    setIsLoading(true);
    setCurrentPage(selectedPage);
    const formattedStartDate = moment(
      initialAdvanceFormValue.dateOfBirthFrom,
    ).format("YYYY-MM-DD");
    const formattedEndDate = moment(
      initialAdvanceFormValue.dateOfBirthTo,
    ).format("YYYY-MM-DD");
    const queryParams = constructQueryParameters(
      formattedStartDate,
      formattedEndDate,
      selectedSortMethod,
    );
    const { areaId, clusterId, zoneId, regionId, chapterId, districtId, blockId } = values;

    const {
      areaName,
      clusterName,
      zoneName,
      regionName,
      chapterName,
      districtName,
      blockName,
    } = orgNames;
    const orgParams = [
      areaId !== null && areaName !== null && areaName !== ""
        ? `areaName=${areaName}`
        : "",
      clusterId !== null && clusterName !== null && clusterName !== ""
        ? `clusterName=${clusterName}`
        : "",
      zoneId !== null && zoneName !== null && zoneName !== ""
        ? `zoneName=${zoneName}`
        : "",
      regionId !== null && regionName !== null && regionName !== ""
        ? `regionName=${regionName}`
        : "",
      chapterId !== null && chapterName !== null && chapterName !== ""
        ? `chapterName=${chapterName}`
        : "",
      districtId !== null && districtName !== null && districtName !== ""
        ? `districtName=${districtName}`
        : "",
      blockId !== null && blockName !== null && blockName !== ""
        ? `blockName=${blockName}`
        : "",
    ]
      .filter(Boolean)
      .join("&");
    try {
      const url = `${
        SERVICES.CHAPTER_CONTRIBUTION_CYCLE
      }?${constructQueryParameters(
        formattedStartDate,
        formattedEndDate,
        selectedSortMethod,
      )}&page=${selectedPage}&size=${10}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        // const filteredData = data?.data?.content.filter(
        //   (item) => item?.paymentOrder?.captureVerified !== true,
        // );
        setSearchData(data.data);
        setData(data?.data?.content);
        const areAllActive = data?.data?.content?.every(
          (item) => item.status === "ACTIVE",
        );

        if (areAllActive) {
          setSelectAll(true);
        } else {
          setSelectAll(false);
        }
        const bankSelection = data?.data?.content?.reduce((acc, item) => {
          if (item.chapterId && item.defaultDepositBankId !== null) {
            acc[item.chapterId] = item.defaultDepositBankId;
          }
          return acc;
        }, {});
        setRowBankSelections(bankSelection);
        setSearchParams(
          `${queryParams}${
            orgParams ? `&${orgParams}` : ""
          }&pageNumber=${selectedPage}&pageSize=${10}`,
        );
      } else {
        console.error("Failed to fetch contribution data");
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  const handleShowAll = async () => {
    setIsLoading(true);
    setShowAll(true);
    // setCurrentPage(selectedPage);
    const formattedStartDate = moment(
      initialAdvanceFormValue.dateOfBirthFrom,
    ).format("YYYY-MM-DD");
    const formattedEndDate = moment(
      initialAdvanceFormValue.dateOfBirthTo,
    ).format("YYYY-MM-DD");
    const queryParams = constructQueryParameters(
      formattedStartDate,
      formattedEndDate,
      selectedSortMethod,
    );
    const { areaId, clusterId, zoneId, regionId, chapterId, districtId, blockId } = values;

    const {
      areaName,
      clusterName,
      zoneName,
      regionName,
      chapterName,
      districtName,
      blockName,
    } = orgNames;
    const orgParams = [
      areaId !== null && areaName !== null && areaName !== ""
        ? `areaName=${areaName}`
        : "",
      clusterId !== null && clusterName !== null && clusterName !== ""
        ? `clusterName=${clusterName}`
        : "",
      zoneId !== null && zoneName !== null && zoneName !== ""
        ? `zoneName=${zoneName}`
        : "",
      regionId !== null && regionName !== null && regionName !== ""
        ? `regionName=${regionName}`
        : "",
      chapterId !== null && chapterName !== null && chapterName !== ""
        ? `chapterName=${chapterName}`
        : "",
      districtId !== null && districtName !== null && districtName !== ""
        ? `districtName=${districtName}`
        : "",
      blockId !== null && blockName !== null && blockName !== ""
        ? `blockName=${blockName}`
        : "",
    ]
      .filter(Boolean)
      .join("&");
    try {
      const url = `${SERVICES.GET_CAPTURED_REPORT}?${queryParams}${
        orgParams ? `&${orgParams}` : ""
      }&pageSize=${
        searchData?.totalElements
      }&paymentMethodTypes=CARD,NET_BANKING,WALLET,UPI&paymentOrderStatus=SUCCESS&paymentTransactionStatus=CAPTURED&capturedVerified=false`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        // const filteredData = data?.data?.content.filter(
        //   (item) => item?.paymentOrder?.captureVerified !== true,
        // );
        setSearchData(data.data);
        setData(data?.data?.content);
        setSearchParams(
          `${queryParams}${orgParams ? `&${orgParams}` : ""}&pageSize=${10}`,
        );
      } else {
        console.error("Failed to fetch contribution data");
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  const formatUINType = (type) => {
    if (type) {
      return type.replace(/_/g, " ").toUpperCase();
    }
    return "";
  };
  const renderAppliedFilter = (paramKey, displayName, value, onRemove) => {
    return (
      queryParams.get(paramKey) && (
        <AppliedFilter
          filter={{
            displayName,
            value,
          }}
          onRemove={onRemove}
        />
      )
    );
  };
  const onRemoveFilter = (filterKey) => {
    const updatedSearchParams = new URLSearchParams(searchParams);
    updatedSearchParams.delete(filterKey);
    setSearchParams(updatedSearchParams.toString());
  };
  const onRemoveTwoFilter = (...filterKeys) => {
    const updatedSearchParams = new URLSearchParams(searchParams);
    filterKeys.forEach((key) => {
      updatedSearchParams.delete(key);
    });

    setSearchParams(updatedSearchParams.toString());
  };
  const convertTypeFormat = (type) => {
    const formattedType = type
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

    return formattedType;
  };
  const getEntityTitlesForPaymentgatewayTypes = () => {
    return queryParams
      ?.get("paymentGatewayTypes")
      ?.split(",")
      ?.map((name) => name.trim());
  };
  const getEntityTitlesForPaymentmethodTypes = () => {
    return queryParams
      ?.get("paymentMethodTypes")
      ?.split(",")
      ?.map((name) => convertTypeFormat(name.trim()));
  };
  const getEntityTitlesForUinTypes = () => {
    return queryParams
      ?.get("uinTypes")
      ?.split(",")
      ?.map((name) => convertTypeFormat(name.trim()));
  };
  const getEntityTitlesForReceiptTypes = () => {
    return queryParams
      ?.get("receiptType")
      ?.split(",")
      ?.map((name) => name.trim());
  };

  const filters = [
    // org values
    renderAppliedFilter("areaId", "Area", searchParams.get("areaName"), () =>
      onRemoveTwoFilter("areaId", "areaName"),
    ),
    renderAppliedFilter("clusterId", "Cluster", searchParams.get("clusterName"), () =>
      onRemoveTwoFilter("clusterId", "clusterName"),
    ),
    renderAppliedFilter("zoneId", "Zone", searchParams.get("zoneName"), () =>
      onRemoveTwoFilter("zoneId", "zoneName"),
    ),
    renderAppliedFilter(
      "regionId",
      "Region",
      searchParams.get("regionName"),
      () => onRemoveTwoFilter("regionId", "regionName"),
    ),
    renderAppliedFilter(
      "chapterId",
      "Chapter",
      searchParams.get("chapterName"),
      () => onRemoveTwoFilter("chapterId", "chapterName"),
    ),
    renderAppliedFilter(
      "districtId",
      "District",
      searchParams.get("districtName"),
      () => onRemoveTwoFilter("districtId", "districtName"),
    ),
    renderAppliedFilter("blockId", "Block", searchParams.get("blockName"), () =>
      onRemoveTwoFilter("blockId", "blockName"),
    ),
    // Advance Search
    renderAppliedFilter(
      "paymentGatewayTypes",
      "Payment Gateway",
      getEntityTitlesForPaymentgatewayTypes()?.join(", "),
      () => onRemoveFilter("paymentGatewayTypes"),
    ),
    renderAppliedFilter(
      "paymentMethodTypes",
      "Payment Method",
      getEntityTitlesForPaymentmethodTypes()?.join(", "),
      () => onRemoveFilter("paymentMethodTypes"),
    ),
    renderAppliedFilter("amount", "Amount", searchParams.get("amount"), () =>
      onRemoveFilter("amount"),
    ),
    renderAppliedFilter(
      "orderId",
      "Order Id",
      searchParams.get("orderId"),
      () => onRemoveFilter("orderId"),
    ),
    renderAppliedFilter(
      "uinTypes",
      "Uin Types",
      getEntityTitlesForUinTypes()?.join(", "),
      () => onRemoveFilter("uinTypes"),
    ),
    renderAppliedFilter(
      "receiptType",
      "Receipt Types",
      getEntityTitlesForReceiptTypes()?.join(", "),
      () => onRemoveFilter("receiptType"),
    ),
    renderAppliedFilter("sort", "Sorting", searchParams.get("sort"), () =>
      onRemoveFilter("sort"),
    ),
    // Personal Deatils
    renderAppliedFilter(
      "memberId",
      "Member Id",
      searchParams.get("memberId"),
      () => onRemoveFilter("memberId"),
    ),
    renderAppliedFilter(
      "fullName",
      "Member Name",
      searchParams.get("fullName"),
      () => onRemoveFilter("fullName"),
    ),
    renderAppliedFilter(
      "from",
      "Date Range",
      `${moment(searchParams.get("from")).format("DD-MMM-YYYY")} - ${moment(
        searchParams.get("to"),
      ).format("DD-MMM-YYYY")}`,
      () => onRemoveTwoFilter("from", "to"),
    ),
  ];
  useEffect(() => {
    if (queryParams.get("amount") === null) {
      setAmountValue("");
    }
    if (queryParams.get("orderId") === null) {
      setOrderIdValue("");
    }
    if (queryParams.get("memberId") === null) {
      setPersonalDetails((prevalues) => ({
        ...prevalues,
        memberId: "",
      }));
    }
    if (queryParams.get("fullName") === null) {
      setPersonalDetails((prevalues) => ({
        ...prevalues,
        fullName: "",
      }));
    }
    if (queryParams.get("from") === null) {
      setInitialAdvanceFormValue((preValues) => ({
        ...preValues,
        dateOfBirthFrom: initialAdvanceFormValue?.dateOfBirthFrom,
        dateOfBirthTo: initialAdvanceFormValue?.dateOfBirthTo,
      }));
    }
    if (queryParams.get("sort") === null) {
      setSelectedSortMethod("");
    }
  }, [
    queryParams.get("amount"),
    queryParams.get("orderId"),
    queryParams.get("memberId"),
    queryParams.get("fullName"),
    clearContributions,
    // queryParams.get("from")
    queryParams.get("sort"),
  ]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [unselectedItems, setUnselectedItems] = useState([]);

  // console.log("data", data);

  // console.log("selectedItems", selectedItems);
  // console.log("unselectedItems", unselectedItems);

  const handleSelectAllClick = () => {
    if (selectAll) {
      setSelectedItems([]);
      setUnselectedItems([]);
    } else {
      setSelectedItems(data.map((item) => item?.chapterId));
      setUnselectedItems([]);
    }
    setSelectAll(!selectAll);
  };
  const handleChangePage = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
    handlePageChange(selectedPage.selected);
    // onPageChange(selectedPage.selected);
  };
  const pageCount = searchData.totalPages;
  const CHAPTER_LEVEL_CONTRIBUTION_CYCLE_COL = [
    {
      displayName: (
        // <div
        //   style={{
        //     display: "flex",
        //     flexDirection: "column",
        //     // alignItems: "center",
        //   }}
        // >
        //   <span style={{ color: "white" }}>Activate Contribution</span>
        //   <Checkbox
        //     checked={selectAll}
        //     onChange={handleSelectAllClick}
        //     sx={{
        //       color: "white",
        //       "&.Mui-checked": {
        //         color: "white",
        //       },
        //       justifyContent: "flex-start",
        //     }}
        //   />
        // </div>
        <Checkbox
          checked={selectAll}
          onChange={handleSelectAllClick}
          sx={{
            color: "white",
            "&.Mui-checked": {
              color: "white",
            },
            justifyContent: "flex-start",
          }}
        />
      ),
    },
    {
      displayName: "Chapter Name",
    },
    {
      displayName: "Login Level",
    },
    {
      displayName: "Org structure",
    },
    // {
    //   displayName: "Order ID",
    // },
    // {
    //   displayName: "Amount",
    // },
    // {
    //   displayName: "Receipt No.",
    // },
    {
      displayName: (
        <div>
          <span style={{ color: "white" }}>Default Deposit Bank</span>
          {/* <AutoCompleteDropdown
            getOptionLabel={(option) => option.bankName}
            options={getOptions(bankTypes, "id")}
            // label="Drawn on Bank"
            name="paymentMethods"
            value={selectedBankType}
            onChange={(selectedValue) => {
              setSelectedBankType(selectedValue?.value);
              setSelectedBankName(selectedValue?.bankName);
              setRowBankSelections({});
            }}
            inputProps={{ required: true }}
            useHiddenInput
            style={{ width: "150px" }}
          /> */}
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.bankName}
            options={getOptions(bankTypes, "id")}
            name="paymentMethods"
            value={selectedBankType}
            onChange={(selectedValue) => {
              const newSelectedBankType = selectedValue?.value;
              setSelectedBankType(newSelectedBankType);
              setSelectedBankName(selectedValue?.bankName);
              const updatedBankSelections = {};
              data.forEach((chapter) => {
                updatedBankSelections[chapter.chapterId] = newSelectedBankType;
              });
              setRowBankSelections(updatedBankSelections);
            }}
            inputProps={{ required: true }}
            useHiddenInput
            style={{ width: "150px" }}
          />
        </div>
      ),
    },
  ];
  const getCommonCellStyle = (index) => ({
    borderBottom: `1px solid ${index % 2 === 1 ? "#62B6DA" : "#ffff"}`,
    borderTop: `1px solid ${index % 2 === 1 ? "#62B6DA" : "#ffff"}`,
    textAlign: "left",
  });
  const toggleItemSelection = (itemId) => {
    // console.log("itemId", itemId);
    if (selectedItems.includes(itemId)) {
      setSelectedItems(selectedItems.filter((id) => id !== itemId));
      setUnselectedItems([...unselectedItems, itemId]);
    } else {
      setSelectedItems([...selectedItems, itemId]);
      setUnselectedItems(unselectedItems.filter((id) => id !== itemId));
    }
  };
  // console.log("selected Item", selectedItems);
  const removeFilter = () => {
    setClearContributions(true);
    setShowAll(false);
    setSearchParams("");
    setSelectedItems([]);
    setUnselectedItems([]);
    setCurrentPage(0);
    setSelectAll(false);
    setPersonalDetails({
      memberId: null,
      fullName: null,
    });
    setTimeout(() => {
      setClearContributions(false);
      setSearchPerformed(false);
      // setShowFilter(false);
    }, 100);
  };
  const fetchData = async () => {
    setSearchPerformed(true);
    if (
      !initialAdvanceFormValue.dateOfBirthFrom ||
      !initialAdvanceFormValue.dateOfBirthTo
    ) {
      toast.show("Please select date", AlertStatus.ERROR);
      return;
    }
    const formattedStartDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.dateOfBirthFrom,
    );
    const formattedEndDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.dateOfBirthTo,
    );
    try {
      setIsLoading(true);
      const url = `${
        SERVICES.CHAPTER_CONTRIBUTION_CYCLE
      }?${constructQueryParameters(
        formattedStartDate,
        formattedEndDate,
        selectedSortMethod,
      )}&size=${500}`;
      const response = await get(url);
      // console.log(response);
      if (response.ok) {
        const data = await response.json();
        // const filteredData = data?.data?.content.filter(
        //   (item) => item?.paymentOrder?.captureVerified !== true,
        // );
        setSearchData(data.data);
        setData(data?.data?.content);
        // console.log("viewData", data?.data?.content);
        // setRowBankSelectionAfterFetch()
        // data?.data?.content.forEach(chapter => {
        //   state[chapter.chapterId] = chapter.defaultDepositBankId;
        // });
        // const bankSelection = data.reduce((acc, item) => {
        //   if (item.chapterId && item.defaultDepositBankId !== null) {
        //     acc[item.chapterId] = item.defaultDepositBankId;
        //   }
        //   return acc;
        // }, {});

        // console.log("bankSelection", bankSelection);
        // setRowBankSelectionAfterFetch(bankSelection);
        const areAllActive = data?.data?.content?.every(
          (item) => item.status === "ACTIVE",
        );

        if (areAllActive) {
          setSelectAll(true);
        } else {
          setSelectAll(false);
        }
        const bankSelection = data?.data?.content?.reduce((acc, item) => {
          if (item.chapterId && item.defaultDepositBankId !== null) {
            acc[item.chapterId] = item.defaultDepositBankId;
          }
          return acc;
        }, {});

        // Set the bank selection in state
        // console.log("bankSelection", bankSelection);
        setRowBankSelections(bankSelection);
        const queryParams = constructQueryParameters(
          formattedStartDate,
          formattedEndDate,
          selectedSortMethod,
        );
        const { areaId, clusterId, zoneId, regionId, chapterId, districtId, blockId } =
          values;

        const {
          areaName,
          clusterName,
          zoneName,
          regionName,
          chapterName,
          districtName,
          blockName,
        } = orgNames;
        const orgParams = [
          areaId !== null && areaName !== null && areaName !== ""
            ? `areaName=${areaName}`
            : "",
          clusterId !== null && clusterName !== null && clusterName !== ""
            ? `clusterName=${clusterName}`
            : "",
          zoneId !== null && zoneName !== null && zoneName !== ""
            ? `zoneName=${zoneName}`
            : "",
          regionId !== null && regionName !== null && regionName !== ""
            ? `regionName=${regionName}`
            : "",
          chapterId !== null && chapterName !== null && chapterName !== ""
            ? `chapterName=${chapterName}`
            : "",
          districtId !== null && districtName !== null && districtName !== ""
            ? `districtName=${districtName}`
            : "",
          blockId !== null && blockName !== null && blockName !== ""
            ? `blockName=${blockName}`
            : "",
        ]
          .filter(Boolean)
          .join("&");
        setSearchParams(`${queryParams}${orgParams ? `&${orgParams}` : ""}`);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    }
  };
  // console.log("row bank selection", rowBankSelections);
  const nonDefaultBankChapters = Object.entries(rowBankSelections).map(
    ([chapterId, bankId]) => ({
      chapterId: Number(chapterId),
      bankId,
    }),
  );
  const defaultBankChapters = data.map((chapter) => ({
    chapterId: chapter.chapterId,
    bankId: selectedBankType,
  }));

  // console.log("ActiveChaptersBank", nonDefaultBankChapters);
  const filteredChapters = nonDefaultBankChapters.filter((chapter) =>
    selectedItems.includes(chapter.chapterId),
  );
  const unfilteredChapters = nonDefaultBankChapters.filter(
    (chapter) => !selectedItems.includes(chapter.chapterId),
  );

  // console.log("Filtered Chapters:", filteredChapters);
  // console.log("Unfiltered Chapters:", unfilteredChapters);

  // const defaultBankChapters = data.map(()=>)
  // console.log("nonDefaultBankChapters", nonDefaultBankChapters);
  const handleSubmit = async () => {
    setIsLoading(true);
    const queryParams = new URLSearchParams(location.search);
    // const FromDateQueryParam = queryParams.get("from");
    // const fromDate = FromDateQueryParam
    //   ? moment(FromDateQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
    //   : "";
    // const ToDateQueryParam = queryParams.get("to");
    // const toDate = ToDateQueryParam
    //   ? moment(ToDateQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
    //   : "";

    const uinTypeQueryParam = queryParams.get("uinTypes");
    const uinTypes = uinTypeQueryParam
      ? uinTypeQueryParam.split(",").filter(Boolean)
      : [];
    const paymentMethodQueryParam = queryParams.get("paymentMethodTypes");
    const paymentMethodsTypes = paymentMethodQueryParam
      ? paymentMethodQueryParam.split(",").filter(Boolean)
      : [];
    const paymentGatewayQueryParam = queryParams.get("paymentGatewayTypes");
    const paymentGatewayTypes = paymentGatewayQueryParam
      ? paymentGatewayQueryParam.split(",").filter(Boolean)
      : [];
    let formattedStartDate = formatDateToYYYMMDDTimeStamp(
      initialAdvanceFormValue.dateOfBirthFrom,
    );
    let formattedEndDate = formatDateToYYYMMDDTimeStamp(
      initialAdvanceFormValue.dateOfBirthTo,
    );

    // ✅ If start date and end date are same, increase end date by one day with time = 00:00:00
    if (
      moment(initialAdvanceFormValue.dateOfBirthFrom).isSame(
        initialAdvanceFormValue.dateOfBirthTo,
        "day",
      )
    ) {
      formattedEndDate = moment(initialAdvanceFormValue.dateOfBirthTo)
        .add(1, "day")
        .format("YYYY-MM-DDT00:00:00");
    }

    const data = {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      activeChapters: filteredChapters,
      inActiveChapters: unfilteredChapters,

      defaultBankChapters: [
        {
          chapterId: 0,
          bankId: selectedBankType,
        },
      ],
    };
    const url = SERVICES.CREATE_CHAPTER_LEVEL_CONTRIBUTION_CYCLE;
    try {
      const response = await post(url, data);
      if (response.ok) {
        toast.show(
          "Contribution Cycle Created Successfully",
          AlertStatus.SUCCESS,
        );
        fetchData();
      }
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    } finally {
      setIsLoading(false);
    }
  };
  const getRows = (data) =>
    data.map((contInfo, index) => {
      // const isSelected =
      //   (selectAll && !unselectedItems.includes(contInfo?.chapterId)) ||
      //   selectedItems.includes(contInfo?.chapterId) ||
      //   // (contInfo?.status === "ACTIVE" &&
      //   //   // selectAll &&
      //   //   !unselectedItems.includes(contInfo?.chapterId));
      //   (contInfo?.status === "ACTIVE" &&
      //     !unselectedItems.includes(contInfo?.chapterId));
      const isSelected = selectAll
        ? !unselectedItems.includes(contInfo?.chapterId)
        : selectedItems.includes(contInfo?.chapterId);

      const handleCheckboxClick = () => {
        toggleItemSelection(contInfo?.chapterId);
      };
      return (
        <TableRow key={contInfo.id}>
          <TableCell sx={getCommonCellStyle(index)}>
            <Checkbox
              checked={isSelected}
              selected={isSelected}
              onClick={() => handleCheckboxClick()}
            />
          </TableCell>
          {/* <TableCell sx={getCommonCellStyle(index)}>
            {contInfo.paymentOrder?.memberId}
          </TableCell> */}
          <TableCell sx={getCommonCellStyle(index)}>
            {contInfo?.name || "NA"}
          </TableCell>
          <TableCell sx={getCommonCellStyle(index)}>Chapter</TableCell>
          {/* <TableCell sx={getCommonCellStyle(index)}>{`${searchParams.get(
            "areaName",
          )}/${searchParams.get("zoneName")}/${searchParams.get(
            "regionName",
          )}`}</TableCell> */}
          <TableCell sx={getCommonCellStyle(index)}>{`${
            contInfo.areaName ?? "NA"
          }/${contInfo.clusterName ?? "NA"}/${contInfo.zoneName ?? "NA"}/${contInfo.regionName ?? "NA"}/${
            contInfo.chapterName ?? "NA"
          }`}</TableCell>
          <TableCell sx={getCommonCellStyle(index)}>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.bankName}
              options={getOptions(bankTypes, "id")}
              // label="Drawn on Bank"
              name="paymentMethods"
              value={rowBankSelections[contInfo.chapterId] || selectedBankType}
              // onChange={(selectedValue) => {
              //   setSelectedBankType(selectedValue?.value);
              //   setSelectedBankName(selectedValue?.bankName);
              // }}
              onChange={(selectedValue) => {
                // Update the row-specific selection
                setRowBankSelections((prevSelections) => ({
                  ...prevSelections,
                  [contInfo.chapterId]: selectedValue?.value,
                }));
              }}
              inputProps={{ required: true }}
              useHiddenInput
              style={{ width: "150px" }}
            />
          </TableCell>
        </TableRow>
      );
    });
  useEffect(() => {
    if (!selectAll) {
      return;
    }
    if (selectAll) {
      const currentSelectedItems = data
        .map((item) => item?.chapterId)
        .filter((id) => !unselectedItems.includes(id));

      setSelectedItems((prevSelectedItems) => [
        ...prevSelectedItems,
        ...currentSelectedItems,
      ]);
    } else {
      const currentUnselectedItems = data.map((item) => item?.chapterId);

      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter((id) => !currentUnselectedItems.includes(id)),
      );
    }
  }, [selectAll, data, unselectedItems]);
  useEffect(() => {
    handleBankTypes();
  }, []);
  return (
    <div style={{ width: "100%", overflowY: "hidden" }}>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <PageSyncCal />
      <Heading title="Chapter Contribution Cycle Details" />
      <OuterContainerStyles marginTop="24px" marginBottom="24px">
        <div style={styles.container}>
          <div style={styles.filter}>
            <form style={styles.left} onSubmit={onSubmit} ref={formRef}>
              <DateRangePicker
                label="Date"
                name="date"
                startDateVal={initialAdvanceFormValue.dateOfBirthFrom}
                endDateVal={initialAdvanceFormValue.dateOfBirthTo}
                onChange={(startDate, endDate) => {
                  setInitialAdvanceFormValue({
                    ...initialAdvanceFormValue,
                    dateOfBirthFrom: startDate,
                    dateOfBirthTo: endDate,
                  });
                }}
              />
              <Popover
                heading="Organization Structure"
                minWidth={413}
                minHeight={300}
              >
                <OrganizationStructure
                  clearValues={clearContributions}
                  setNameValues={setOrgNames}
                  onUpdateValues={updateOrganizationStructureValues}
                />
              </Popover>
              {/* <Popover heading="Advance Search" minHeight={100} minWidth={403}>
                <AdvancedSearch
                  clearValues={clearContributions}
                  onAmountChange={handleAmountChange}
                  updateSortingMethod={updateSortingMethod}
                  amountValue={amountValue}
                  orderIdValue={orderIdValue}
                  onOrderIdChange={handleOrderIdChange}
                  onDataEnterdBy={handleDataEnterdBy}
                  setAdvancedSearchValues={setAdvancedSearchValues}
                />
              </Popover> */}
              {/* <Popover
                heading="Personal Details"
                minWidth={300}
                minHeight={100}
              >
                <PersonalDetailsSearch
                  onDetailsChange={handlePersonalDetailsChange}
                  personalDetails={personalDetails}
                />
              </Popover> */}
              <Button type="submit">Search</Button>
            </form>
            <Button cancel onClick={removeFilter}>
              Reset
            </Button>
          </div>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "20px",
            }}
          >
            <div />
            <div>
              <ExportButton data={data} />
            </div>
          </div> */}
          {searchPerformed && (
            <div style={styles.filterWrapper}>
              <div style={styles.filterContainer}>
                {filters.map((filter, index) => (
                  <>{filter}</>
                ))}
              </div>
            </div>
          )}
          <div style={styles.main}>
            {appliedFilters.length ? (
              <div style={styles.filterWrapper}>
                <div style={styles.filterContainer}>
                  {/* {appliedFilters.map((filter) => (
                    <AppliedFilter
                      key={filter.key}
                      filter={filter}
                      onRemove={onRemoveFilter}
                    />
                  ))} */}
                </div>
                {/* <div style={styles.clearAll} onClick={clearAllFilter}>
                  Clear
                </div> */}
              </div>
            ) : null}
            {!searchPerformed ? (
              <div style={styles.initialContent}>
                <SearchIconWithPeople width={100} />
                <span style={styles.text}>Choose your Search Filter</span>
              </div>
            ) : data?.length > 0 ? (
              <div>
                {/* <GenericTable
                  tableData={data}
                  data={searchData}
                  headers={tableHeaders}
                  onPageChange={handlePageChange}
                /> */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    marginBottom: "20px",
                    gap: "20px",
                  }}
                >
                  {/* <div /> */}
                  {/* <div>
                    <Button cancel onClick={handleShowAll}>
                      Show All
                    </Button>
                  </div> */}
                  {/* <div>
                    <ExportButton data={data} />
                  </div> */}
                </div>
                <NewTable
                  columns={CHAPTER_LEVEL_CONTRIBUTION_CYCLE_COL}
                  rows={getRows(data, toggleItemSelection, selectedItems)}
                  tableBodyTheme="#E8F6FC"
                />
                <Pagination
                  pageCount={pageCount}
                  onPageChange={handleChangePage}
                  forcePage={currentPage}
                />
                <ButtonContainer>
                  {/* <Button cancel>Cancel</Button> */}
                  <Button onClick={handleSubmit}>Submit</Button>
                </ButtonContainer>
              </div>
            ) : (
              <div style={styles.initialContent}>
                <EmptyFileIcon width={100} />
                <span style={styles.text}>
                  No data found with current Filters
                </span>
              </div>
            )}
          </div>
          {isLoading && <Loader />}
        </div>
      </OuterContainerStyles>
    </div>
  );
}
export default ChapterLevelContributionCycleDetails;

const ButtonContainer = styled.div`
  display: flex;
  padding: 24px 30px;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

// If we want to use AutoComplete Dropdown use commented Code otherwise use the above code
